import { Component } from "@angular/core";
import { NavController } from "@ionic/angular";
import { GlobalErrorHandlerService } from "src/app/services/global-errors/global-error-handler.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { ResponsibleGamingService } from "src/app/services/responsible-gaming-service/responsible-gaming.service";

@Component({
  selector: "app-resend-pin",
  templateUrl: "./resend-pin.component.html",
  styleUrls: ["./resend-pin.component.scss"],
})
export class ResendPinComponent {
  public error: GlobalErrorHandlerService = null;
  public resendDisabled: boolean = false;

  constructor(
    public navCtrl: NavController,
    public responsibleProvider: ResponsibleGamingService,
    public successMessageService: SuccessMessageService
  ) {
    this.successMessageService.clearMessage();
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.resendDisabled = false;
  }

  onResendPIN() {
    this.successMessageService.clearMessage();
    this.error = null;

    this.resendDisabled = true;
    //call service here when it is available.
    this.responsibleProvider.callResendPin().subscribe({
      next: (response) => {
        if (response.result == 1) {
          this.successMessageService.setMessage(
            "We have sent your Personal Identification Number (PIN) to your email address."
          );
        }
      },
      error: (error) => {
        console.error("onResendPIN error = ", error);

        error.setErrorMessage(
          "There was an issue trying to send your Personal Identification Number (PIN) to your email address. Please contact customer support."
        );
        this.error = error;
      }
    });
  }
}
